"use client";

import React from "react";
import styled from "styled-components";

interface RecommendationRateProps {
  rate: number;
  threshold?: number;
}

const Container = styled.div<{ $isGood?: boolean }>(({ theme, $isGood }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  padding: "2px 4px",
  borderRadius: "4px",
  backgroundColor: $isGood
    ? theme.kallisto.color.background.static.backgroundSuccessContrast
    : theme.kallisto.color.background.static.backgroundDisabled,
  data: {
    fontSize: theme.kallisto.font.size[150],
    lineHeight: "normal",
    fontWeight: theme.kallisto.font.weight.bold,
    color: $isGood
      ? theme.kallisto.color.text.static.textOnDark
      : theme.kallisto.color.text.static.textSecondary,
  },
}));

const RecommendationRate: React.FC<RecommendationRateProps> = ({
  rate,
  threshold = 65,
}) => {
  const isGood = rate > threshold;

  return (
    <Container $isGood={isGood}>
      <data value={rate.toFixed(0)}>{rate.toFixed(0)}%</data>
    </Container>
  );
};

export default RecommendationRate;
